import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=7e0c8f4e&scoped=true"
import script from "./OnboardingLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingLayout.vue?vue&type=script&lang=js"
import style0 from "./OnboardingLayout.vue?vue&type=style&index=0&id=7e0c8f4e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0c8f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0c8f4e')) {
      api.createRecord('7e0c8f4e', component.options)
    } else {
      api.reload('7e0c8f4e', component.options)
    }
    module.hot.accept("./OnboardingLayout.vue?vue&type=template&id=7e0c8f4e&scoped=true", function () {
      api.rerender('7e0c8f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/OnboardingLayout.vue"
export default component.exports